import Axios from '../Axios';

const userService = {
    login,
    logout
};

async function login(email, password, resolve, error) {
    return await Axios.post(`auth/login/`, {
        email, password
    })
    .then(res => resolve(res))
    .catch(res => error(res))
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('token');
}


export default userService;